import app from '@/app';
import templateUrl from './parameterEvolution-detail.html';

/**
 * Whether {@code campaign} can still be offered in the considered-campaigns row {@code index}.
 * A campaign already chosen in ANOTHER row is filtered out: duplicates would compute the same
 * comparison series twice and skew the RMSE. The row's own current value is always kept, or the
 * ui-select would blank out the selection it is displaying.
 */
export function isConsideredCampaignAvailableAt(consideredCampaigns, index, campaign) {
	if (!consideredCampaigns || !campaign) {
		return true;
	}
	return !consideredCampaigns.some(
		(selected, position) => position !== index && selected && selected.id === campaign.id
	);
}

/* @ngInject */
function ParameterEvolutionDetailController($controller, ParameterEvolution, Principal, AlertService, $state) {
	var $ctrl = this;

	$ctrl.allRateType = ['FIXED', 'VARIABLE'];

	Principal.identity().then(account => {
		$ctrl.currentAccount = account;
	});

	$controller('AbstractEntityDetailController', {
		$ctrl,
		resource: ParameterEvolution,
		type: 'parameterEvolution'
	});

	$ctrl.save = () => {
		if (!$ctrl.readonly) {
			$ctrl.isSaving = true;
			const onSuccess = () => {
				AlertService.success('entity.update.message', {
					type: 'parameterEvolution',
					name: $ctrl.entity.name
				});
				$ctrl.isSaving = false;
				$state.go('^');
			};
			const onError = () => {
				$ctrl.isSaving = false;
			};
			if ($ctrl.entity.id) {
				ParameterEvolution.update($ctrl.entity, onSuccess, onError);
			} else {
				ParameterEvolution.create($ctrl.entity, onSuccess, onError);
			}
		}
	};

	$ctrl.onRoadSelected = road => {
		$ctrl.entity.road = road;
		$ctrl.entity.headMilestone = road.headMilestone || null;
		$ctrl.entity.tailMilestone = road.tailMilestone || null;
	};

	$ctrl.onOrganizationChange = () => {
		$ctrl.entity.road = null;
		$ctrl.entity.headMilestone = null;
		$ctrl.entity.tailMilestone = null;
		$ctrl.entity.campaign = null;
		$ctrl.entity.consideredCampaigns = [];
	};

	$ctrl.onRoadTypeChange = () => {
		$ctrl.entity.road = null;
		$ctrl.entity.headMilestone = null;
		$ctrl.entity.tailMilestone = null;
		$ctrl.entity.campaign = null;
		$ctrl.entity.consideredCampaigns = [];
	};

	$ctrl.byOrganization = value =>
		$ctrl.entity.organization && value.organization && value.organization.id == $ctrl.entity.organization.id;

	$ctrl.byOwner = value =>
		$ctrl.entity.organization && value.owner && value.owner.id == $ctrl.entity.organization.id;

	// Returns the predicate for the row's ui-select, so each row filters out the campaigns
	// already picked in the other rows.
	$ctrl.availableConsideredCampaigns = index =>
		campaign => isConsideredCampaignAvailableAt($ctrl.entity.consideredCampaigns, index, campaign);

	$ctrl.addConsideredCampaign = () => {
		$ctrl.entity.consideredCampaigns = $ctrl.entity.consideredCampaigns || [];
		$ctrl.entity.consideredCampaigns.push({});
	};

	$ctrl.removeConsideredCampaign = idx => {
		$ctrl.entity.consideredCampaigns.splice(idx, 1);
	};

	$ctrl.$onInit = () => {
		if ($ctrl.entity && !$ctrl.entity.id) {
			$ctrl.entity.consideredCampaigns = [];
		}

		if ($ctrl.entity && $ctrl.entity.road && $ctrl.allRoads) {
			const matchedRoad = ($ctrl.allRoads.content || []).find(r => r.id === $ctrl.entity.road.id);
			if (matchedRoad) {
				$ctrl.entity.roadtype = matchedRoad.roadtype;
			}
		}
	};
}

app.component('parameterEvolutionDetail', {
	templateUrl,
	controller: ParameterEvolutionDetailController,
	require: {
		parent: '^parameterEvolutionSearch'
	},
	bindings: {
		$transition$: '<',
		entity: '<',
		allRoads: '<',
		allCampaigns: '<',
		allConstantSets: '<',
		allGrowthRates: '<'
	}
});
